<template>
  <div>
    <div
      class="font-medium text-sm text-light-900 dark:text-dark-50 leading-tight"
    >
      <div class="">
        <div class="line-clamp-2" :style="{ overflowWrap: 'break-word' }">
          {{ stripTags(post?.content) }}
        </div>
        
        <div class="flex items-center space-x-3 text-2xs text-light-800 dark:text-dark-400 mt-1.5">
          <div class="flex items-center font-bold space-x-1.5 text-light-900 dark:text-dark-50">
            <UserPicture
              :user="owner"
              size="4xs"
              is-hide-badges
              is-link
            />

            <span>{{ owner?.name }}</span>
          </div>

          <span v-if="(post?.reactions ?? []).length > 0">
            <IconBase name="cute/heart-fill" class="-mt-[3px] mr-0.5" :width="10" />

            {{ post?.reactions.length ?? 0 }}

          </span>

          <span v-if="(post?.posts ?? []).length > 0">
            <IconBase name="cute/comment-2-fill" class="-mt-[3px] mr-[1px]" :width="12" />
            {{ post?.posts.length ?? 0 }}
          </span>

          <span>{{ post?.createdAt ? dayjs(post.createdAt).fromNow(true) : '' }}</span>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Post, Theme } from '@/classes'
import UsersStore from '@/store/users'
import dayjs from 'dayjs'

const props = withDefaults(defineProps<{
  post: Post | null
}>(), {
  post: null
})

const usersStore = UsersStore()


const owner = computed(() => props.post?.owner ? usersStore.getItem(props.post.owner) : null)
</script>